import React from 'react';
import RecommendJobItems from './RecommendedJobsSection/RecommendJobItems';
import CompanyItems from './RecommendedCompanySection/CompanyItems';
import BenefitsSection from './BenefitsSection/BenefitsSection';
import HeroSection from './HeroSection/HeroSection';
import BrandSlider from './BrandSlider/BrandSlider';
import ClientMetrics from './ClientMetrics/ClientMetrics';

import './home.css'

const Home = () => {
  return (
    <div className="home__container">
      <HeroSection/>
      <ClientMetrics />
      {/* <BrandSlider/> */}
      <div className="home__recommend-section">
        <RecommendJobItems/>
        <CompanyItems/>
      </div>
      <BenefitsSection />
    </div>
  );
};

export default Home;
